import {defineStore} from "pinia";
import piniaPersistConfig from "@/config/piniaPersist";
import {FilterStore} from "@/v2/store/modules/filter";

const id = "AuthState";

/**
 * 授權相關store
 */
export const AuthStore = defineStore({
	id: id,
	//權杖本身在 httpOnly cookie（頁面腳本讀不到），這裡只記「是否已登入」
	state: () => ({
		login: false,
		permission: []
	}),
	getters: {
		//是否正常登入
		isLogin: state => {
			return state.login;
		},
        //獲取權限
		getPermission: state => {
			return state.permission;
		}
	},
	actions: {
		//登入 / 登出
		setLogin(login) {
			this.login = login;
			//身分變動 (登入 / 登出 / 逾時 / 模擬登入 / 回總會) → 清空所有列表頁保留的查詢條件。
			//模擬登入是 router.replace 而非整頁 reload, sessionStorage 會存活下來,
			//不清會讓上一個身分的教會 / 族群 / 分類 seq 殘留成錯的條件。
			FilterStore().clear();
		},
		//設定權限表
		setPermission(permission) {
			this.permission = permission;
		}
	},
	persist: piniaPersistConfig(id)
});
